export default {
    tabs: [],
}



// WEBPACK FOOTER //
// ./src/modules/tabs/state.js